import type { FC, SVGProps } from 'react'

export const PlayPreviousArrow: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.69444 5C7.07798 5 7.38889 5.31091 7.38889 5.69444V11.0606L16.7482 5.95553C17.5376 5.52497 18.5 6.0963 18.5 6.99547V18.0045C18.5 18.9037 17.5376 19.475 16.7482 19.0445L7.38889 13.9394V19.3056C7.38889 19.6891 7.07798 20 6.69444 20C6.31091 20 6 19.6891 6 19.3056V5.69444C6 5.31091 6.31091 5 6.69444 5Z"
      fill="currentColor"
    />
  </svg>
)
